export default {
    namespaced: true,
    state: {
        data: {
            itemsShop: [],
        },
        leaders: [],
        halloweenData: {
            treatBasketClaimed: false,
            treatBasketPlaced: false
        },
        halloweenTreatsData: {
            collected: 0,
            message: "",
            loading: true
        },
        userPoints: 0
    },
    getters: {
        data(state) {
            return state.data;
        },
        leaders(state) {
            return state.leaders;
        },    
        userPoints(state) {
            return state.userPoints;
        },
        halloweenData(state) {
            return state.halloweenData;
        },
        halloweenTreatsData(state) {
            return state.halloweenTreatsData;
        }
    },
    mutations: {
        setValue(state, data) {
            state[data[0]] = data[1];
        },
        basketClaimed(state) {
            state.halloweenData.treatBasketClaimed = true;
        },
    },
    actions: {
        setValue({ commit }, data) {
            commit('setValue', data)
        },
        questClaimed({ commit }) {
            commit('questClaimed');
        },
        basketClaimed({ commit }) {
            commit('basketClaimed');
        },
        resetHalloweenTreatsData({ commit }) {
            commit('setValue', ['halloweenTreatsData', {
                collected: 0,
                message: "",
                loading: true
            }]);
        }
    }
};